<template>

  <!-- Modal component -->
  <modal :show.sync="showModal" >
    <color-picker :color.sync="user.color" ></color-picker>
  </modal>
  <div class="card card-content">
    <div class="card-header">
      <div class="header">
        <breadcrumb></breadcrumb>
        <h1>Ajouter un utilisateur</h1>
      </div>
      <div class="actions">
        <a class="btn btn-link" v-link="{ path: '/administration'}" >Voir tous les utilisateurs</a>
        <button class="btn btn-link" @click="saveUser" :class="{ inactive: $userValidation.invalid }">Sauvegarder l'utilisateur</button>
      </div>
    </div>
    <div class="card-block">
      <validator name="userValidation">
        <form novalidate>

          <fiedset>

            <!-- Username -->
            <div class="form-group" >
              <label for="username">Nom d'utilisateur</label>
              <input class="form-control"
                id                  = "username"
                type                = "text"
                v-model             = "user.username"
                v-validate:username = "validationRules.username"
              >
            </div>

            <!-- Email address -->
            <div class="form-group" >
              <label for="email">Adresse email</label>
              <input class="form-control"
                id               = "email"
                type             = "text"
                v-model          = "user.email"
                v-validate:email = "validationRules.email"
              >
            </div>

            <!-- First name -->
            <div class="form-group" >
              <label for="firstname">Prénom</label>
              <input class="form-control"
                id                   = "firstname"
                type                 = "text"
                v-model              = "user.firstname"
                v-validate:firstname = "validationRules.firstname"
              >
            </div>

            <!-- Last name -->
            <div class="form-group" >
              <label for="lastname">Nom</label>
              <input class="form-control"
                id                  = "lastname"
                type                = "text"
                v-model             = "user.lastname"
                v-validate:lastname = "validationRules.lastname"
              >
            </div>

            <!-- Password -->
            <div class="form-group" >
              <label for="password">Mot de passe</label>
              <input class="form-control"
                id                  = "password"
                type                = "password"
                v-model             = "user.password"
                v-validate:password = "validationRules.password"
              >
            </div>

            <!-- Password confirmation -->
            <div class="form-group" >
              <label for="password_confirmation">Retapez le mot de passe</label>
              <input class="form-control"
                id                              = "password_confirmation"
                type                            = "password"
                v-model                         = "user.password_confirmation"
                v-validate:passwordConfirmation = "validationRules.passwordConfirmation"
              >
            </div>

            <!-- Color -->
            <div class="form-group" >
              <label for="color">Couleur</label>
              <span
                id               = "color"
                type             = "text"
                class            = "colorpicker"
                :style           = "'background-color: ' + user.color "
                diabled          = "true"
                @click.prevent   = "modalColor()"
              >
            </span>
            </div>

            <!-- Phone number -->
            <div class="form-group" >
              <label for="phone">Numéro de téléphone</label>
              <input class="form-control"
                id               = "phone"
                type             = "text"
                v-model          = "user.phone"
                v-validate:phone = "validationRules.phone"
              >
            </div>

          </fiedset>

          <!-- Errors -->
          <div v-if="$userValidation.errors" >
            <hr>
            <ul>
              <li class="errors" v-for="error in $userValidation.errors" >{{ error.message }}</li>
            </ul>
          </div>

        </form>
      </validator>
    </div>
    <div class="card-footer">
      <div class="actions">
        <a class="btn btn-link" v-link="{ path: '/administration'}" >Voir tous les utilisateurs</a>
        <button class="btn btn-link" @click="saveUser" :class="{ inactive: $userValidation.invalid }">Sauvegarder l'utilisateur</button>
      </div>
    </div>
  </div>

</template>

<script>
// Vuex specifics
import { addUser } from 'src/vuex/actions/userActions'
import { add as validationRules } from 'src/validations/user.js'
import { validateUsername, usernameUnique, validateEmail, emailUnique, validateHex, validatePhone } from 'src/validations/customRules.js'

// Notifications message
import toastr from 'toastr'

// Import components
import Modal from 'src/components/modals/Modal.vue'
import ColorPicker from 'src/components/modals/ColorPicker.vue'
import Breadcrumb from '../nav/Breadcrumb.vue'

var defaultColor = '#4FC3F7'

export default{
  vuex: {
    getters: {
      userCreated: ({ users }) => users.userCreated
    },
    actions: { addUser }
  },
  validators: {
    usernameUnique,
    validateUsername,
    validateEmail,
    emailUnique,
    validateHex,
    validatePhone,
    passwordMatch (val) {
      return this.vm.user.password === val
    }
  },
  data () {
    return {
      user: {
        color: defaultColor,
        phone: null,
        username: null,
        lastname: null,
        password: null,
        firstname: null,
        password_confirmation: null
      },
      validationRules,
      showModal: false
    }
  },
  watch: {
    'userCreated': function (value) {
      if (value === true) {
        toastr.success('Nouvel utilisateur ajouté')
        this.$router.go('/administration')
      }
    }
  },
  components: { ColorPicker, Modal, Breadcrumb },
  methods: {
    saveUser () { this.addUser(this.user) },
    modalColor () { this.showModal = true }
  }
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// UserAdd.vue?111956da